exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.nil-sa-partials-confirmauthenticator-style__confirmAuthenticators{position:absolute;background-color:hsla(0,0%,100%,.8);left:0;right:0;top:0;bottom:0}div.nil-sa-partials-confirmauthenticator-style__confirmAuthenticators .nil-sa-partials-confirmauthenticator-style__form{border-top:1px solid #dfdfdf;background-color:#efefef;position:absolute;bottom:0;right:0;left:0;text-align:center}", ""]);

// exports
exports.locals = {
	"confirmAuthenticators": "nil-sa-partials-confirmauthenticator-style__confirmAuthenticators",
	"form": "nil-sa-partials-confirmauthenticator-style__form"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-2!../node_modules/postcss-loader/lib??ref--2-3!../node_modules/less-loader/dist/cjs.js??ref--2-4!./components/partials/ConfirmAuthenticator/style.less
// module id = 462
// module chunks = 0